jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	  //  $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	  //  });
	const homeConf = document.getElementById('homeConf');
	let isHome = false;
	if (homeConf != null) {
		const homeConfFormat = JSON.parse(homeConf.innerText);
		
		isHome = homeConfFormat.homepage;
	}

	if(isHome){
		$(window).on('scroll', function() {
			const position = 1000;
			const scrollPosition = $(window).scrollTop();
			const windowHeight = $(window).height();
		
			// Check if the element is in view
			if (scrollPosition + windowHeight > position) {
				$('.t4s-section-header').addClass('background-on');
			}
			if (scrollPosition + windowHeight < position) {
				$('.t4s-section-header').removeClass('background-on');
			}
		});
	} else {
		$('.t4s-section-header').addClass('background-on');
	}
});


